import { API_BASE } from './config';

async function fetchJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return response.json();
}

export const slugifyCmeTitle = (text, id) => {
  const base = String(text || 'cme-session')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return base ? `${base}-${id}` : `cme-session-${id}`;
};

export function getCmeIdFromSlug(slug) {
  const raw = String(slug || '');
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = raw.match(/-(\d+)$/);
  return match ? Number(match[1]) : null;
}

export async function fetchDigitalCme(filters = {}) {
  const params = new URLSearchParams();
  if (filters.establishment_id != null) {
    params.set('establishment_id', String(filters.establishment_id));
  }
  if (filters.doctor_id != null) {
    params.set('doctor_id', String(filters.doctor_id));
  }

  const query = params.toString();
  const url = `${API_BASE}/master/digital-cme${query ? `?${query}` : ''}`;
  const data = await fetchJson(url);
  return Array.isArray(data) ? data : [];
}

export async function fetchDigitalCmeById(id) {
  return fetchJson(`${API_BASE}/master/digital-cme/${id}`);
}
